import React from "react";
import { Text } from "evergreen-ui";
import "../../assets/styles/fieldset.scss";

const Fieldset = ({ children, legend }) => {
  return (
    <fieldset>
      <legend>
        <Text size={300}>{legend}</Text>
      </legend>
      {children}
    </fieldset>
  );
};

export default Fieldset;
